// src/index.js (JS)

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { persistor, store } from './redux-stuffs/store/store';

import { LocaleProvider } from 'antd';            // antd v3
import i18n from './i18n';                        // your react-i18next init (JS)
import { antdLocales, applyMomentLocale } from './uiLocale'; // antd + moment helpers

import App from './App';
import * as serviceWorker from './serviceWorker';

// ensure moment starts in the same locale as i18n
applyMomentLocale(i18n.language);

// Root wrapper so LocaleProvider re-renders on language change
function Root({ lng }) {
  const locale = antdLocales[lng] || antdLocales.en;
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <LocaleProvider locale={locale}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </LocaleProvider>
      </PersistGate>
    </Provider>
  );
}

// render function we can call on language changes
function render(lng = i18n.language) {
  ReactDOM.render(<Root lng={lng} />, document.getElementById('root'));
}

// re-render & sync moment whenever language changes
i18n.on('languageChanged', (lng) => {
  applyMomentLocale(lng);
  render(lng);
});

// initial render
render();

// CRA service worker note
serviceWorker.unregister();
